<template>
    <div>
        <el-dialog title="新增消息" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false"
            z-index="100">
            <el-form :model="form">
                <el-form-item label="标题" :label-width="formLabelWidth">
                    <el-input v-model="form.title" autocomplete="off" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="内容" :label-width="formLabelWidth">
                    <Uediter :key="1" id="editor" :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc">
                    </Uediter>
                </el-form-item>
                <el-form-item label="发送对象" :label-width="formLabelWidth">
                    <el-radio v-model="form.radio" label="0">全部</el-radio>
                    <el-radio v-model="form.radio" label="1">指定用户</el-radio>
                    <el-input type="textarea" :rows="2" v-model="userName" v-if="form.radio == 1" disabled>
                    </el-input>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="addMessage">确 定</el-button>
            </div>

        </el-dialog>
        <UserList :open="isOpen" @closeUserList="getIsOpen" @getUserId="userIdFunc" @getUserName="userNameFunc"></UserList>
    </div>
</template>
<script>
import UserList from './UserList.vue'
import Uediter from '@/components/UE.vue';
import messageApi from '@/api/setting/message.js';
export default {
    props: ['message'],
    components: { Uediter, UserList },
    data() {
        return {
            dialogFormVisible: false,
            form: {
                title: '', // 标题
                content: '', // 内容
                sendobjects: '1', // 发送对象
                radio: '0', // 选择用户的方式
                assign: '', // 指定用户
            },
            formLabelWidth: '120px',
            /*富文本框配置*/
            ueditor: {
                config: {
                    initialFrameWidth: 400,
                    initialFrameHeight: 500
                },
            },
            isOpen: false, // 指定用户列表变量
            userId: "",
            userName: "",
        }
    },
    methods: {
        /*获取富文本内容*/
        contentChangeFunc(e) {
            this.form.content = e;
        },
        // 关闭组件
        handleCancel() {
            this.userName = ''
            this.form.title = ''
            this.form.content = ''
            this.form.sendobjects = ''
            this.form.radio = '0'
            this.dialogFormVisible = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        // 确定（新增）
        addMessage() {
            // console.log(this.form);
            // 判断每一项都填了才能继续执行
            if (!this.form.title.trim() || !this.form.content.trim()) {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            }

            if (this.form.radio == '1' && this.userId == "") {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            }
            // console.log('test', this.form)
            const title = this.form.title;
            const content = this.form.content;

            const sendobjects = this.form.radio == '0' ? '0' : this.userId
            // console.log(sendobjects)

            // 新增 请求
            messageApi.getAddMessage({ title: title, content: content, sendobjects: sendobjects }).then(response => {
                this.$message({
                    message: '新增成功',
                    type: 'success'
                });
                this.$emit('add-success');
            }).catch(error => {
                console.error(error);
            });

            this.handleCancel();
            // 清空表单数据
            // this.form.title = '';
            // this.form.content = '';
            // this.form.sendobjects = '';
            // this.form.type = '';
            // this.dialogFormVisible = false
            // this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        getIsOpen(val) {
            this.isOpen = val;
        },
        userIdFunc(val) {
            // console.log("接收", val)
            this.userId = val;
            // console.log("传参", this.userId);
        },
        userNameFunc(val) {
            console.log("用户名称", val);
            this.userName = val;
        }
    },
    watch: {
        message(newVal) {
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        },
        'form.radio'(newVal) {
            if (newVal === '1') {
                this.isOpen = true;
            } else {
                this.isOpen = false;
            }
        }

    },
}
</script>




// WEBPACK FOOTER //
// src/views/setting/message/components/AddView.vue